import React from 'react';
import { motion } from 'framer-motion';
import Marquee from 'react-fast-marquee';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Mike Rodriguez',
      role: 'Owner, TechFix Pro',
      avatar: 'MR',
      quote: 'This app cut my pricing time by 80%. I used to spend 10 minutes researching each phone - now it takes seconds.',
      rating: 5,
    },
    {
      name: 'Sarah Chen',
      role: 'Manager, iRepair NYC',
      avatar: 'SC',
      quote: 'The repair tracking alone is worth it. Our customer complaints dropped 60% since we started using the automated notifications.',
      rating: 5,
    },
    {
      name: 'James Wilson',
      role: 'Owner, Mobile Medics',
      avatar: 'JW',
      quote: 'Finally, an app that understands what phone resellers actually need. The profit calculator is incredibly accurate.',
      rating: 5,
    },
    {
      name: 'Lisa Park',
      role: 'Director, Phone Hub Chain',
      avatar: 'LP',
      quote: 'We deployed this across 12 stores. Pricing consistency improved overnight and our margins increased by 15%.',
      rating: 5,
    },
    {
      name: 'David Thompson',
      role: 'Owner, Gadget Galaxy',
      avatar: 'DT',
      quote: 'The eBay integration is brilliant. Real-time data means I never overpay on trade-ins anymore.',
      rating: 5,
    },
    {
      name: 'Amanda Foster',
      role: 'Manager, Quick Fix Mobile',
      avatar: 'AF',
      quote: 'Best investment we made this year. The digital waivers save us hours of paperwork every week.',
      rating: 5,
    },
  ];

  const TestimonialCard = ({ testimonial }) => (
    <div className="testimonial-card w-[350px] p-6 mx-4 flex-shrink-0" data-testid={`testimonial-${testimonial.name.toLowerCase().replace(' ', '-')}`}>
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
          {testimonial.avatar}
        </div>
        <div>
          <h4 className="text-white font-semibold">{testimonial.name}</h4>
          <p className="text-slate-400 text-sm">{testimonial.role}</p>
        </div>
      </div>
      
      <div className="flex gap-1 mb-3">
        {[...Array(testimonial.rating)].map((_, i) => (
          <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" />
        ))}
      </div>
      
      <div className="relative">
        <Quote className="w-6 h-6 text-primary/30 absolute -top-1 -left-1" />
        <p className="text-slate-300 text-sm leading-relaxed pl-4">
          {testimonial.quote}
        </p>
      </div>
    </div>
  );

  return (
    <section className="py-24 md:py-32 relative overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <span className="text-sm font-mono tracking-widest uppercase text-primary mb-4 block">
            Testimonials
          </span>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6">
            Loved by
            <span className="text-gradient"> Repair Pros</span>
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            See what electronics businesses are saying about 2A Valuence
          </p>
        </motion.div>
      </div>

      {/* Marquee Row 1 */}
      <div className="marquee-container mb-6">
        <Marquee gradient={false} speed={40}>
          {testimonials.slice(0, 3).map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} />
          ))}
        </Marquee>
      </div>

      {/* Marquee Row 2 (reverse direction) */}
      <div className="marquee-container">
        <Marquee gradient={false} speed={40} direction="right">
          {testimonials.slice(3).map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} />
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default TestimonialsSection;
